<template>
  <div>
    <b-container>
      <b-row>
        <b-col cols="8">
          <b-form-input
            id="table-search"
            v-model="searchField"
            placeholder="Search Configurations"
            type="text"
            v-on:change="sanitizeInput"
          />
        </b-col>
        <b-col cols="4">
          <b-button
            variant="primary"
            class="btn ml-3 btn-info"
            @click="fetchSearchConfigurations"
          >
            Search
          </b-button>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col cols="12">
          <b-table
            v-b-scrollspy
            outlined
            striped
            hover
            :items="items"
            head-variant="light"
            :fields="tableFields"
            :filter="searchField"
            show-empty
            empty-text="No Configurations found."
          >
            <template v-slot:cell(configurationId)="data">
              <router-link
                class="navigation-links"
                :to="{
                  name: 'editConfiguration',
                  params: { clientId: data.item.clientId, id: data.item.configurationId }
                }"
              >
                {{ data.item.configurationId }}
              </router-link>
              <p>
                <small>
                  {{ data.item.description }}
                </small>
              </p>
            </template>
            <template v-slot:cell(SK)="data">
              <router-link
                class="navigation-links"
                :to="{
                  name: 'configuration',
                  params: { clientId: data.item.SK }
                }"
              >
                {{ data.item.SK }}
              </router-link>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { dataAPI } from '../services/DataAPI'

export default {
  data() {
    return {
      items: [],
      tableFields: [
        {
          key: 'configurationId',
          label: 'ConfigurationID',
          sortable: true
        },
        {
          key: 'description',
          label: 'Description',
          sortable: true
        },
        {
          key: 'clientId',
          label: 'Publisher',
          sortable: true
        }
      ],
      searchField: ''
    }
  },
  computed: {
    currentUserToken() {
      return this.$store.state.auth.userToken
    }
  },
  methods: {
    fetchSearchConfigurations() {
      dataAPI(this.currentUserToken)
        .getSearchConfigurations(this.searchField)
        .then(items => {
          this.items = items
        })
    },
    sanitizeInput() {
      this.searchField = this.searchField.replace(/[^a-zA-Z0-9-]/g, '')
    }
  }
}
</script>
<style>
.navigation-links {
  text-decoration: underline;
  text-underline-position: under;
}
</style>
